<template>
  <v-form @submit.prevent ref="form">
    <row-form :doc="doc" :headers="headers" />

    <v-btn class="mt-5" color="amber" @click="onSubmit">Submit</v-btn>
    <slot></slot>
  </v-form>
</template>

<script>
// @ is an alias to /src
import RowForm from "@/views/user/exercises/timeline/RowForm";
import { mapState } from "vuex";

export default {
  name: "RowAdd",
  components: {
    RowForm,
  },
  props: {
    headers: Array,
  },
  data() {
    return {
      valid: true,
      doc: {},
    };
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    onSubmit() {
      this.$emit("saveNote", this.doc);
    },
  },
};
</script>
